<template>
  <div>
    <activity-redirect-to-office></activity-redirect-to-office>
    <component 
      :is="currentComponent" 
      v-bind="welcomeActivityProperties"
      @onApplyEMIClick = "showMobileViewActivity"
    ></component>

  </div>
</template>

<script>
import LandingPageDekstopView from "./LandingPageDekstopView";
import WelcomeCobrandingActivity from "./WelcomeCobrandingActivity";
import { ImageResourcesUtil } from "../../../utils/ImageResourcesUtil";
import WelcomeActivity from "../WelcomeActivity";
import UrlParams from "../../../data/model/UrlParams";
import CoBrandingDataHolder from "../../../data/model/CoBrandingDataHolder";
import ActivityRedirectToOffice from "../../layout/ActivityRedirectToOffice";
import EzUtils from "../../../utils/EzUtils";
import LoanScopeDataHolder from "../../../data/model/LoanScopeDataHolder";

const MERCHANT = "MERCHANT";

export default {
  name: "LandingPage",
  components: { LandingPageDekstopView, WelcomeCobrandingActivity, WelcomeActivity,ActivityRedirectToOffice },

  data: () => ({
    currentComponent: 'welcome-activity',
  }),

  created() {
    if(!this.showRetailerLandingPage){
      this.currentComponent = "welcome-activity";
    }else{
      this.currentComponent = "landing-page-dekstop-view";
    }
  },

  methods: {

    showMobileViewActivity(){
      // if(this.isMIDExist){
      //   this.currentComponent = "welcome-cobranding-activity";
      // }else{
      //   this.currentComponent = "welcome-activity";
      // } 
      this.currentComponent = "welcome-activity";
    },

    benifitPoints() {
      let benifitPointsArray = [];
      if(this.isOnboardingProcess){
        benifitPointsArray.push("100% digital, paperless, collateral-free process");
        benifitPointsArray.push("No repeat applications, just one-time approval needed");
        benifitPointsArray.push("Borrow as low as ₹3,000 or as high as ₹20 Lakh");
        benifitPointsArray.push("Banks & NBFCs like ICICI, Kotak, Aditya Birla, Eduvanz, LiquiLoans.");
        benifitPointsArray.push("Used by leading players like Byju, Toppr, Aakash, BITS Pilani.");
      }else{
        benifitPointsArray.push("Take instant loans whenever you need, 24x7");
        benifitPointsArray.push("100% digital, paperless, collateral-free process");
        benifitPointsArray.push("No repeat applications, just one-time approval needed");
        benifitPointsArray.push("Borrow as low as ₹3,000 or as high as ₹20 Lakh");
        benifitPointsArray.push("Get affordable and flexible EMI for online/offline purchases");
      }

      return benifitPointsArray;
    },

    processSteps() {
      let retailerProcessConfigObj;
      if(this.isOnboardingProcess){
        retailerProcessConfigObj = this.processStepsForOnBoarding();
      }else{
        retailerProcessConfigObj = CoBrandingDataHolder.getRetailerProcessConfig()
      }
      let retailerProcessConfigArr = [];
      if(retailerProcessConfigObj){
        var processStepsCount = Object.keys(retailerProcessConfigObj).length;
        for(let step = 1; step <= processStepsCount ; step++){
          retailerProcessConfigArr.push(retailerProcessConfigObj[step]);
        }
      }
      return retailerProcessConfigArr;
    },

    processStepsForOnBoarding(){
      let onBordingProcessConfig = {
        "1": {
            "retailerProcessTitle": "Sign up",
            "retailerProcessDescription": "Within few minutes signup with mobile number and OTP",
            "retailerProcessImageName": "Eligibility"
        },
        "2": {
            "retailerProcessTitle": "Submit Paperless",
            "retailerProcessDescription": "100% online with digital agreement and documents(GST, Cancelled Cheque, PAN)",
            "retailerProcessImageName": "MobileTab"
        },
        "3": {
            "retailerProcessTitle": "Completed",
            "retailerProcessDescription": "Verification of submitted documents",
            "retailerProcessImageName": "ClickHand"
        },
        "4": {
            "retailerProcessTitle": "Merchant live with EzCred",
            "retailerProcessDescription": "Cheers...You'll receive a mail with credentials to on borad customer.",
            "retailerProcessImageName": "HappyMan"
        }
      };
      return onBordingProcessConfig;
    },

    headingDetails(){
      let headingObj = {}
      if(this.isOnboardingProcess){
        headingObj.title = "One stop EzCred - Lending Platform for Purchase Financing";
        headingObj.text = 
        "Your Customers can enjoy the convenient, affordable and flexible EMI on EzCred. No credit card or credit score required.";
      }else{
        headingObj.title = CoBrandingDataHolder.getRetailerHeadingTitle() 
          ? CoBrandingDataHolder.getRetailerHeadingTitle() : "Convenient, Affordable and Flexible EMI";
        headingObj.text =  CoBrandingDataHolder.getRetailerHeadingDescription() 
          ? CoBrandingDataHolder.getRetailerHeadingDescription() : 
        "Enjoy the convenient affordable and flexible EMI on EzCred. No credit card or credit score required.";
      }
      return headingObj;
    },

    benifitTitle(){
      if(this.isOnboardingProcess){
        return "Benefits when you partner with EzCred";
      }else{
        return CoBrandingDataHolder.getRetailerBenefitTitle() 
          ? CoBrandingDataHolder.getRetailerBenefitTitle() : "Benefits when you pay with EzCred";
      }
    },

    processTitle(){
      return this.isOnboardingProcess ? "How to Partner with EzCred" : "How it works";
    },

    applyButtonText(){
      return this.isOnboardingProcess ? "Start Onboarding Application" : "Get Easy EMI";
    },

    showRetailerOnBoardingExtraDetails(){
     return this.isOnboardingProcess && CoBrandingDataHolder.showRetailerOnBoardingExtraDetails();
    },

  },

  computed: {

    ezCredLogoSrc() {
      return ImageResourcesUtil.getImageLink(
        ImageResourcesUtil.EZCRED_COLOR_LOGO_WITH_NAME
      );
    },

    coBrandingLogoSrc() {
      return CoBrandingDataHolder.getCoBrandingLogoUrl();
    },

    isMIDExist() {
        return UrlParams.getMerchantID() ? true : false;
    },

    showRetailerLandingPage(){
      return CoBrandingDataHolder.showRetailerLandingPage() || LoanScopeDataHolder.isOnboardingLoan();
    },

    welcomeActivityProperties: function() {
      let props = {
        ezCredLogoSrc : this.ezCredLogoSrc,
        coBrandingLogoSrc : this.coBrandingLogoSrc,
        benifitPoints : this.benifitPoints(),
        processSteps : this.processSteps(),
        header : this.headingDetails(),
        benifitTitle : this.benifitTitle(),
        processTitle : this.processTitle(),
        applyButtonText : this.applyButtonText(),
        showRetailerOnBoardingExtraDetails : this.showRetailerOnBoardingExtraDetails(),
      }
      return props;
    },

    isOnboardingProcess() {
      return LoanScopeDataHolder.isOnboardingLoan();
    },
  },
};
</script>


